import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { InmersysRouter } from "./InmersysRouter";
import { LayoutHome } from "../layout/LayoutHome";
import { LayoutNotFound } from "../layout/LayoutNotFound";
import { Home } from "../pages/home/Home";
import { AuthRouter } from "./AuthRouter";
import { PathRoot } from "./type_router";

/**
 * El enrutador global llama a
 * @AuthRouter El auth
 * @InmersysRouter Inmersys una vez logeado
 */
export const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={PathRoot.root} element={<LayoutHome />}>
                    <Route index element={<Home />} />
                </Route>
                <Route path={PathRoot.auth} element={<AuthRouter />} />
                <Route path={PathRoot.inmersys} element={<InmersysRouter />} />
                <Route path={PathRoot.notfound} element={<LayoutNotFound />} />
            </Routes>
        </BrowserRouter>
    );
};
